<template>
  <div>
    <van-nav-bar title="我的外出办事申请" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template slot="right">
        <van-icon name="edit" size="25"/>
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @refresh="onRefresh"
        @load="onLoad">
        <van-swipe-cell v-for="item in list" :key="item.id" disabled>
          <van-card :tag=awayStatusFormatter(item.status)
                    :title=title(item.createUserName)
                    class="goods-card"
                    @click="jumpToApplyPage(item.status, item.taskId, item.processInstanceId, item.appNo, item.processDefinitionId)">
            <template slot="thumb">
              <img :src="listIcon" style="width: 80px;"/>
            </template>
            <template slot="tags">
              <span>开始时间：{{ item.beginTime }}</span><br>
              <span>结束时间：{{ item.endTime }}</span><br>
              <span>外出天数：{{ item.day }}</span><br>
              <span>外出原因：{{ item.reason }}</span><br>
              <span>办事地点：{{ item.place }}</span><br>
            </template>
            <template slot="footer">
              <div>{{ item.createTime }}</div>
            </template>
          </van-card>
          <template slot="right">
            <van-button square text="删除" type="danger" class="delete-button"/>
          </template>
        </van-swipe-cell>
      </van-list>
      <van-empty description="暂无数据" v-if="emptyShow"/>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Toast} from "vant";
import {isLogin, isWechat} from "../../../utils/util";

export default {
  name: "awayList",
  data() {
    return {
      list: [],
      listIcon: "../../../static/images/holiday_apply.png",
      loading: false,
      finished: false,
      refreshing: false,
      userId: '',
      userClassify: 0,
      userGroup: 0,
      refereeStatus: 0,
      finishedText: "上滑加载更多...",
      emptyShow: false,
      size: 10,
      current: 1,
      total: 0,
      modelKey: "away",
      processDefinitionId: '',
      processInstanceId: '',
      appNo: '',
      awayStatusList: [],
      userInfo: {},
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.loading = true;
    this.dictionaryInit();
  },
  methods: {
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.userInfo = user;
          this.getAwayList();
        }
      );
    },
    toAwayApply() {
      this.$fetch("/attence-api/blade-flow/process/getFlowProcessByKey", {
        modelKey: this.modelKey,
      }).then(
        res => {
          const data = res.data;
          let bladeFlow = {
            taskDefinitionKey: "apply",
            processDefinitionId: data.id,
            processDefinitionKey: data.key,
          };
          this.$bodyPost("/attence-api/blade-flow/process/startProcessApply", bladeFlow).then(
            res => {
              const data = res.data;
              Toast(res.msg);
              this.$router.push({
                path: "/attenceflow/away/form",
                query: {
                  taskId: data.taskId,
                  processInstanceId: data.processInstanceId,
                  appNo: data.appNo,
                  processDefinitionId: data.processDefinitionId,
                  pageType: 1,
                }
              });
            }
          );
        }
      );
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      } else {
        this.current++;
      }
      this.getAwayList();
    },
    dictionaryInit() {
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'away_status'
      }).then(res => {
        const data = res.data;
        this.awayStatusList = data;
        this.getUserInfo();
      });
    },
    awayStatusFormatter(status) {
      let formateName = "";
      this.awayStatusList.forEach((item) => {
        if (status == item.dictKey) {
          formateName = item.dictValue;
        }
      });
      return formateName;
    },
    onRefresh() {
      // 清空列表数据
      this.current = 1;
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getAwayList: function () {
      this.$fetch("/attence-api/blade-away/away/page", {
        current: this.current,
        size: this.size,
        createUser: this.userInfo.id
      }).then(
        res => {
          const data = res.data;
          this.list = this.list.concat(data.records);
          this.total = data.total;
          this.size = data.size;
          this.current = data.current;
          if (this.list.length > 0) {
            this.emptyShow = false;
            if (this.total > this.list.length) {
              this.finishedText = "上滑加载更多...";
            } else {
              // 数据全部加载完成
              this.finished = true;
              this.finishedText = "没有更多了";
            }
          } else {
            this.emptyShow = true;
            this.finished = true;
            this.finishedText = "";
          }
          // 加载状态结束
          this.loading = false;
          console.log("返回的数据：" + JSON.stringify(this.list));
        },
        error => {
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      );
    },
    onClickRight: function () {
      this.toAwayApply();
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    title(name, deptName, empNo) {
      return "申请人：" + name;
    },
    jumpToApplyPage(status, taskId, processInstanceId, appNo, processDefinitionId) {
      if (status == 0) {//加班状态为0是保存
        let bladeFlow = {
          processDefinitionId: processDefinitionId,
          processInstanceId: processInstanceId,
          appNo: appNo,
          processDefinitionKey: this.modelKey,
        };
        this.$bodyPost("/attence-api/blade-flow/process/startProcessApply", bladeFlow).then(
          res => {
            const data = res.data;
            debugger
            Toast(res.msg);
            this.$router.push({
              path: "/attenceflow/away/form",
              query: {
                taskId: data.taskId,
                processInstanceId: data.processInstanceId,
                appNo: data.appNo,
                processDefinitionId: data.processDefinitionId,
                pageType: 1,
              }
            });
          }
        );
      } else {

      }
    }
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.goods-card {
  margin: 0;
  background-color: @white;
}

.delete-button {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/away/list.vue